import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import CustomColumn from '../../../../../customControl/CustomColumn'
import { DatePicker, TimePicker } from 'antd'
import dayjs from 'dayjs'
import Switch from 'react-switch';
import { dateFormatWithTime, formatDate, formatDateyearmonthday, formatOnlyTimeToSQL, HourMinuteFromOnlyTime, isBlank, isNullable } from '../../../../commonClass/CommonValidation'

const convertTimeToMinutes = (time) => {
    if (!time) return 0;
    const [h, m, s] = time.split(":").map(Number);
    return h * 60 + m + (s || 0) / 60;
};

const isDuplicateNonOperatingSlot = (
    newSlot,
    nonOparatingList,
    editingIndex = null
) => {

    const newFromDate = new Date(newSlot.nonOperatingFromDate);
    const newToDate = new Date(newSlot.nonOperatingToDate);

    const newStartTime = convertTimeToMinutes(newSlot.nonOperatingStartTime);
    const newEndTime = convertTimeToMinutes(newSlot.nonOperatingEndTime);

    return nonOparatingList.some((item, index) => {

        if (editingIndex !== null && index === editingIndex) return false;

        const existingFromDate = new Date(item.nonOperatingFromDate);
        const existingToDate = new Date(item.nonOperatingToDate);

        const existingStartTime = convertTimeToMinutes(item.nonOperatingStartTime);
        const existingEndTime = convertTimeToMinutes(item.nonOperatingEndTime);

        // ✅ Date Overlap (correct logic)
        const isDateOverlap =
            newFromDate <= existingToDate &&
            newToDate >= existingFromDate;

        // ✅ Day Overlap
        const isDayOverlap =
            newSlot?.operatedDayId?.some(day =>
                item?.operatedDayId?.includes(day)
            );

        // ✅ Time Overlap
        const isTimeOverlap =
            newStartTime < existingEndTime &&
            newEndTime > existingStartTime;

        return isDateOverlap && isDayOverlap && isTimeOverlap;
    });
};

const NonOperatingDateTimeSection = forwardRef(({
    NonOperatingDateTimeForm,
    setNonOperatingDateTimeForm,
    IsNonOperatingDates,
    dropdownData,
    formErrors,
    setFormErrors,
    disabled,
    setEditDisabled,

    ActivityValidityForm,
    NonOperatingDateList,
    setNonOperatingDateList
}, ref) => {

    const [selectedNonOperatingDay, setselectedNonOperatingDay] = useState({
        IsNonOperatingDates: IsNonOperatingDates || NonOperatingDateList.length > 0 ? true : false,
        NonOperatingDay: {
            nonOperatingFromDate: null,
            nonOperatingToDate: null,
            nonOperatingStartTime: null,
            nonOperatingEndTime: null,
            operatedDayId: [],
            isActive: true
        }
    })
    const [erors, setErrors] = useState({});
    const [isAdd, setIsAdd] = useState(-1)

    const convertOpertedDaysTableFormat = (collection) => {
        return [...collection]?.reduce((acc, curr, index) => {
            acc = [...acc, {
                ...curr, NonOperatingDay: {
                    SeqNo: index + 1,
                    date: `${formatDate(curr?.nonOperatingFromDate)} TO ${formatDate(curr?.nonOperatingToDate)}`,
                    time: `${HourMinuteFromOnlyTime(curr?.nonOperatingStartTime)} TO ${HourMinuteFromOnlyTime(curr.nonOperatingEndTime)}`,
                    DaysName: dropdownData?.weekDayList?.filter(({ value }) => curr?.operatedDayId?.includes(value) && value !== 1)
                        ?.map(({ label }) => label?.slice(0, 3))
                        ?.join(", ")
                }

            }]
            return acc;
        }, [])
    }

    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        if (name === "IsNonOperatingDates") {
            setselectedNonOperatingDay((prev) => (
                {
                    IsNonOperatingDates: value,
                    NonOperatingDay: {
                        nonOperatingFromDate: value ? prev?.NonOperatingDay.nonOperatingFromDate : null,
                        nonOperatingToDate: value ? prev?.NonOperatingDay?.nonOperatingToDate : null,
                        nonOperatingStartTime: value ? prev?.NonOperatingDay?.nonOperatingStartTime : null,
                        nonOperatingEndTime: value ? prev?.NonOperatingDay?.nonOperatingEndTime : null,
                        operatedDayId: []
                    }
                }
            ))
            setNonOperatingDateList((prev) => ({
                ...prev,
                isNonOperatingDates: value,
            }))
        }
        else {
            setselectedNonOperatingDay((prev) => ({
                ...prev,
                NonOperatingDay: {
                    ...prev.NonOperatingDay,
                    [name]: value,
                    operatedDayId: name === 'nonOperatingFromDate' || name === 'nonOperatingToDate' ? [] : prev?.NonOperatingDay?.operatedDayId
                }
            }))
        }
        setErrors({});
    }

    const handleNonOpratingDay = (name, value, isChecked) => {
        setEditDisabled(false);
        setFormErrors(null);

        if (isChecked) {
            const selectedDay = Number(value) === 1 ? dropdownData?.weekDayList?.map(day => day?.value) : [Number(value)]
            setselectedNonOperatingDay((prev) => (
                {
                    ...prev,
                    NonOperatingDay: {
                        ...prev?.NonOperatingDay,
                        operatedDayId: Number(value) === 1 ? dropdownData?.weekDayList?.map(day => day?.value) : [...prev?.NonOperatingDay.operatedDayId, Number(value)]
                    }
                }
            ))
        } else {
            setselectedNonOperatingDay((prev) => (
                {
                    ...prev,
                    NonOperatingDay: {
                        ...prev?.NonOperatingDay,
                        operatedDayId: Number(value) === 1 ? [] : prev?.NonOperatingDay.operatedDayId.filter((dayId) => dayId !== Number(value))
                    }
                }
            ))

        }
        setErrors({});
    }


    const ValidateNonOperatingDay = () => {
        let error = {};

        if (NonOperatingDateTimeForm?.IsNonOperatingDates) {
            if (isBlank?.includes(NonOperatingDateTimeForm?.nonOperatingFromDate)) {
                error.nonOperatingFromDate = "Input Is mandatory, Cannot Leave Blank."
            }
            if (isBlank?.includes(NonOperatingDateTimeForm?.nonOperatingToDate)) {
                error.nonOperatingToDate = "Input Is mandatory, Cannot Leave Blank."
            }
            if (isBlank?.includes(NonOperatingDateTimeForm?.NonOperatingTime)) {
                error.NonOperatingTime = "Input Is mandatory, Cannot Leave Blank."
            }
        }

        return error;
    }

    // Expose the childFunction to the parent's ref
    // useImperativeHandle(ref, () => ({
    //     canValidate: true,
    //     ValidateNonOperatingDateTimeForm: ValidateNonOperatingDateTimeForm
    // }));

    const validNonOpration = () => {
        let errorMassage = {};
        let isError = true;
        if (isNullable?.includes(selectedNonOperatingDay.NonOperatingDay.nonOperatingFromDate)) {
            errorMassage = { ...errorMassage, nonOperatingFromDate: "Please provide input.Please select Valid date." }
            isError = false
        }
        if (isNullable?.includes(selectedNonOperatingDay.NonOperatingDay.nonOperatingToDate)) {
            errorMassage = { ...errorMassage, nonOperatingToDate: "Please provide input.Please select Valid date." }
            isError = false
        }
        if (isNullable?.includes(selectedNonOperatingDay.NonOperatingDay.nonOperatingStartTime)) {
            errorMassage = { ...errorMassage, nonOperatingStartTime: "Please provide input." }
            isError = false
        }
        if (isNullable?.includes(selectedNonOperatingDay.NonOperatingDay.nonOperatingEndTime)) {
            errorMassage = { ...errorMassage, nonOperatingEndTime: "Please provide input." }
            isError = false
        }
        if (selectedNonOperatingDay?.NonOperatingDay?.operatedDayId?.length <= 0) {
            errorMassage = { ...errorMassage, operatedDayId: "Please provide input." }
            isError = false
        }

        const isDuplicate = NonOperatingDateList?.NonOperatingDay?.length > 0 ? isDuplicateNonOperatingSlot(
            selectedNonOperatingDay.NonOperatingDay,
            NonOperatingDateList?.NonOperatingDay,
            isAdd === -1 ? null : isAdd
        ) : false;

        if (isDuplicate) {
            errorMassage = { ...errorMassage, overlapping: "Time or Days are overlapping." }
            isError = false
        }

        setErrors(errorMassage);
        return isError
    }

    const AddUpdateNonOpratingSlot = () => {
        if (validNonOpration()) {
            setEditDisabled(false)
            // if IsAdd is -1 then add slot other edit slot
            if (isAdd === -1) {
                setNonOperatingDateList(
                    (prev) => ({
                        ...prev,
                        isNonOperatingDates: prev?.NonOperatingDay?.length > 0 ? true : selectedNonOperatingDay?.IsNonOperatingDates,
                        NonOperatingDay: prev?.NonOperatingDay?.length > 0 ?
                            [...prev?.NonOperatingDay, { ...selectedNonOperatingDay?.NonOperatingDay, isActive: true }]
                            : [{ ...selectedNonOperatingDay?.NonOperatingDay, isActive: true }]
                    })
                )
            } else if (isAdd >= 0) {
                setNonOperatingDateList((prev) => ({
                    ...prev, NonOperatingDay: prev?.NonOperatingDay?.map((slot, index) => {
                        if (isAdd === index) {
                            slot = selectedNonOperatingDay?.NonOperatingDay
                        }
                        return slot
                    })
                }))
            }

            setselectedNonOperatingDay({
                // IsNonOperatingDates: IsNonOperatingDates,
                IsNonOperatingDates: selectedNonOperatingDay?.IsNonOperatingDates,
                NonOperatingDay: {
                    nonOperatingFromDate: null,
                    nonOperatingToDate: null,
                    nonOperatingStartTime: null,
                    nonOperatingEndTime: null,
                    operatedDayId: [],
                    isActive: true
                }
            })
            setIsAdd(-1)
            setErrors({})
        }
    };


    const getSelectedDays = useCallback((startDate, endDate) => {
        if (isNullable.includes(startDate) || isNullable.includes(endDate)) {
            return []
        }
        const start = new Date(startDate);
        const end = new Date(endDate);

        const days = [];
        let current = new Date(start);

        while (current <= end) {
            days.push(
                current.toLocaleDateString("en-US", { weekday: "short" })
            );
            current.setDate(current.getDate() + 1);
        }

        return days.length >= 7 ? [...days, 'All'] : days;
    }, [selectedNonOperatingDay.NonOperatingDay.nonOperatingToDate]);


    const handleisActive = (val, sr) => {
        setEditDisabled(false);
        setNonOperatingDateList((prev) => ({
            ...prev, NonOperatingDay: prev.NonOperatingDay.map((slot, index) => {
                if (sr === index) {
                    slot = { ...slot, isActive: val }
                }
                return slot
            })
        }))


    }

    const handleSlotEdit = (slot, index) => {
        setEditDisabled(false)
        setIsAdd(index)
        setselectedNonOperatingDay({
            IsNonOperatingDates: NonOperatingDateList?.isNonOperatingDates,
            NonOperatingDay: slot
        })
    }

    const handleSlotRemove = (sr) => {
        setEditDisabled(false);
        setNonOperatingDateList((prev) => ({
            ...prev, NonOperatingDay: prev.NonOperatingDay.filter((slot, index) => sr !== index)
        }))
    }

    const disabledLessThenStartTime = () => {
        const startTimeString =
            selectedNonOperatingDay?.NonOperatingDay?.nonOperatingStartTime;

        if (!startTimeString) return {};

        const [hour, minute] = startTimeString.split(":");
        const startHour = parseInt(hour, 10);
        const startMinute = parseInt(minute, 10);

        return {
            disabledHours: () =>
                [...Array(24).keys()].filter(h => h < startHour)
        };
    };

    return (
        <>
            <div className="row">
                {erors?.overlapping && <div className="text-danger text-center fs_14">{erors?.overlapping}</div>}
                <CustomColumn colNum={12} colLabel={3} colMDLabel={6} colChildren={3} colMDChildren={6} classChildren="align-content-center" labelText='Non-Operating Days (If Any)' labelId='NonOperatingDayRadio'>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="nonoperatingdayyes"
                                    className="form-check-input"
                                    name="nonoperatingday"
                                    value={1}
                                    checked={selectedNonOperatingDay?.IsNonOperatingDates}
                                    onChange={() => handleOnChange("IsNonOperatingDates", true)}
                                    // disabled={disabled || isNullable.includes(ActivityValidityForm?.ValidityFromDate) ? true : isNullable.includes(ActivityValidityForm?.ValidityToDate) ? true : false}
                                    disabled={disabled}
                                />
                                <label htmlFor="nonoperatingdayyes" className="form-check-label"> Yes </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="nonoperatingdayno"
                                    className="form-check-input"
                                    name="nonoperatingday"
                                    value={2}
                                    checked={!selectedNonOperatingDay?.IsNonOperatingDates}
                                    onChange={() => handleOnChange("IsNonOperatingDates", false)}
                                    disabled={disabled || IsNonOperatingDates || NonOperatingDateList?.NonOperatingDay?.length > 0}
                                />
                                <label htmlFor="nonoperatingdayno" className="form-check-label"> No </label>
                            </div>
                        </div>
                    </div>
                </CustomColumn>

                <CustomColumn colXLNum={3} colNum={3} colMDNum={12} colXLLabel={12} colLabel={12} colMDLabel={12} colXLChildren={12} colChildren={12} colMDChildren={12} labelText='Start Date' labelId='nonOperatingFromDate' isRequired={NonOperatingDateTimeForm?.IsNonOperatingDates}>
                    <DatePicker
                        className='antd_input w-100'
                        id='nonOperatingFromDate'
                        format='DD/MM/YYYY'
                        placeholder="DD/MM/YYYY"
                        minDate={ActivityValidityForm?.ValidityFromDate && new Date(ActivityValidityForm?.ValidityFromDate) > new Date() ? dayjs(formatDateyearmonthday(ActivityValidityForm?.ValidityFromDate)) : dayjs(formatDateyearmonthday(new Date()))}
                        maxDate={
                            ActivityValidityForm?.ValidityToDate ? dayjs(formatDateyearmonthday(ActivityValidityForm?.ValidityToDate)) : NonOperatingDateTimeForm?.nonOperatingToDate ? dayjs(formatDateyearmonthday(NonOperatingDateTimeForm?.nonOperatingToDate)) : null}

                        value={!isBlank?.includes(selectedNonOperatingDay?.NonOperatingDay?.nonOperatingFromDate) ? dayjs(formatDateyearmonthday(selectedNonOperatingDay?.NonOperatingDay?.nonOperatingFromDate)) : null}
                        onChange={(e) => handleOnChange('nonOperatingFromDate', e ? `${formatDateyearmonthday(e?.$d)}T00:00:00` : null, false)}
                        disabled={disabled
                            || !selectedNonOperatingDay?.IsNonOperatingDates
                            // || isNullable?.includes(ActivityValidityForm?.ValidityFromDate)
                            // || isNullable?.includes(ActivityValidityForm?.ValidityToDate)
                        }
                    />
                    {erors?.nonOperatingFromDate && <div className="text-danger text-start fs_14">{erors?.nonOperatingFromDate}</div>}
                </CustomColumn>

                <CustomColumn
                    colXLNum={3} colNum={3} colMDNum={12} colXLLabel={12} colLabel={12} colMDLabel={12} colXLChildren={12} colChildren={12} colMDChildren={12}
                    labelText='End Date' labelId='NonOperatingEndDate' isRequired={NonOperatingDateTimeForm?.IsNonOperatingDates}
                >
                    <DatePicker
                        className='antd_input w-100'
                        id='nonOperatingToDate'
                        format='DD/MM/YYYY'
                        placeholder="DD/MM/YYYY"
                        minDate={
                            !isNullable.includes(selectedNonOperatingDay.NonOperatingDay.nonOperatingFromDate) ? dayjs(formatDateyearmonthday(selectedNonOperatingDay?.NonOperatingDay?.nonOperatingFromDate)) : null
                            // dayjs(formatDateyearmonthday(ActivityValidityForm?.ValidityFromDate)) ||
                            // dayjs(formatDateyearmonthday(!isBlank?.includes(NonOperatingDateTimeForm?.nonOperatingFromDate) ? dayjs(formatDateyearmonthday(NonOperatingDateTimeForm?.nonOperatingFromDate)) : new Date())).add(1, 'day')
                        }
                        maxDate={
                            ActivityValidityForm?.ValidityToDate ? dayjs(formatDateyearmonthday(ActivityValidityForm?.ValidityToDate)) : null
                        }
                        value={!isBlank?.includes(selectedNonOperatingDay?.NonOperatingDay?.nonOperatingToDate) ? dayjs(formatDateyearmonthday(selectedNonOperatingDay?.NonOperatingDay?.nonOperatingToDate)) : null}
                        onChange={(e) => handleOnChange('nonOperatingToDate', e ? `${formatDateyearmonthday(e?.$d)}T00:00:00` : null, false)}
                        disabled={
                            disabled
                            || !selectedNonOperatingDay?.IsNonOperatingDates
                            || isNullable?.includes(selectedNonOperatingDay.NonOperatingDay.nonOperatingFromDate)
                            // || isNullable?.includes(ActivityValidityForm?.ValidityToDate)
                        }
                    />
                    {erors?.nonOperatingToDate && <div className="text-danger text-start fs_14">{erors?.nonOperatingToDate}</div>}
                </CustomColumn>

                {/* <CustomColumn colNum={4} labelText='Time' labelId='NonOperatingTime' isRequired={NonOperatingDateTimeForm?.IsNonOperatingDates} >
                    <TimePicker
                        className='form-control defo_border'
                        format='HH:mm:ss'
                        placeholder='HH:mm:ss'
                        id='NonOperatingTime'
                        disabled={disabled || !NonOperatingDateTimeForm?.IsNonOperatingDates}
                        value={NonOperatingDateTimeForm?.NonOperatingTime ? dayjs(dateFormatWithTime(new Date(), NonOperatingDateTimeForm?.NonOperatingTime)) : null}
                        onChange={(e) => handleOnChange('NonOperatingTime', e?.$d ? formatOnlyTimeToSQL(e?.$d) : null)}
                    />
                    {formErrors?.NonOperatingTime && <div className="text-danger text-start fs_14">{formErrors?.NonOperatingTime}</div>}
                </CustomColumn> */}

                <CustomColumn
                    colXLNum={3} colNum={3} colMDNum={12} colXLLabel={12} colLabel={12} colMDLabel={12} colXLChildren={12} colChildren={12} colMDChildren={12}
                    labelText='Start Time' labelId='nonOperatingStartTime' isRequired={NonOperatingDateTimeForm?.IsNonOperatingDates}
                >
                    <TimePicker
                        className='form-control defo_border'
                        format='HH:mm'
                        placeholder='HH:mm'
                        id='nonOperatingStartTime'
                        disabled={disabled || !selectedNonOperatingDay?.IsNonOperatingDates}
                        value={selectedNonOperatingDay?.NonOperatingDay?.nonOperatingStartTime ? dayjs(dateFormatWithTime(new Date(), selectedNonOperatingDay?.NonOperatingDay?.nonOperatingStartTime)) : null}
                        onChange={(e) => handleOnChange('nonOperatingStartTime', e?.$d ? formatOnlyTimeToSQL(e?.$d) : null)}
                    />
                    {erors?.nonOperatingStartTime && <div className="text-danger text-start fs_14">{erors?.nonOperatingStartTime}</div>}
                </CustomColumn>

                <CustomColumn
                    colXLNum={3} colNum={3} colMDNum={12} colXLLabel={12} colLabel={12} colMDLabel={12} colXLChildren={12} colChildren={12} colMDChildren={12}
                    labelText='End Time' labelId='nonOperatingEndTime' isRequired={NonOperatingDateTimeForm?.IsNonOperatingDates} >
                    <TimePicker
                        className='form-control defo_border'
                        format='HH:mm'
                        placeholder='HH:mm:ss'
                        id='nonOperatingEndTime'
                        disabled={disabled || !selectedNonOperatingDay?.IsNonOperatingDates || isNullable?.includes(selectedNonOperatingDay?.NonOperatingDay?.nonOperatingStartTime)}
                        value={selectedNonOperatingDay?.NonOperatingDay?.nonOperatingEndTime ? dayjs(dateFormatWithTime(new Date(), selectedNonOperatingDay?.NonOperatingDay?.nonOperatingEndTime)) : null}
                        onChange={(e) => handleOnChange('nonOperatingEndTime', e?.$d ? formatOnlyTimeToSQL(e?.$d) : null)}
                        disabledTime={() =>
                            disabledLessThenStartTime(
                                selectedNonOperatingDay?.NonOperatingDay?.nonOperatingStartTime
                            )
                        }
                    />
                    {erors?.nonOperatingEndTime && <div className="text-danger text-start fs_14">{erors?.nonOperatingEndTime}</div>}
                </CustomColumn>

                <CustomColumn colNum={10} colLabel={2} colMDLabel={4} colChildren={10} colMDChildren={8} classChildren="align-content-center" labelText='Days' labelId='Days'
                // isRequired={IsScheduleActivity}
                >
                    {dropdownData?.weekDayList && dropdownData?.weekDayList?.map((ele, index) => {
                        return (
                            <div className="form-check-inline" key={index}>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id={ele?.label}
                                    value={ele?.value}
                                    checked={selectedNonOperatingDay?.NonOperatingDay?.operatedDayId?.includes(ele.value) ? true : false}
                                    onChange={(e) => handleNonOpratingDay('operatedDayId', e.target.value, e.target.checked)}
                                    // checked={ActivitySlotsForm?.operatedDayId?.includes(ele?.value)}
                                    disabled={
                                        disabled
                                        || !selectedNonOperatingDay?.IsNonOperatingDates
                                        || isNullable.includes(selectedNonOperatingDay?.NonOperatingDay?.nonOperatingToDate)
                                        || !getSelectedDays(selectedNonOperatingDay.NonOperatingDay.nonOperatingFromDate, selectedNonOperatingDay.NonOperatingDay.nonOperatingToDate).includes(ele?.label?.slice(0, 3))
                                    }

                                />
                                <label htmlFor={ele?.label} className="form-check-label ms-1">{ele?.label}</label>
                            </div>
                        )
                    })}
                    {erors?.operatedDayId && <div className="text-danger text-start fs_14">{erors?.operatedDayId}</div>}
                </CustomColumn>

                <div className="col-12 text-center my-4">
                    <button
                        type="button"
                        className='btn btn-primary'
                        onClick={() => AddUpdateNonOpratingSlot()}
                        disabled={disabled || !selectedNonOperatingDay?.IsNonOperatingDates}
                    >
                        {isAdd === -1 ? "Add" : "Update"}
                    </button>
                </div>

                <div className="form_border">
                    <table className="table table-hover mt-2" >
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th className=''>Time</th>
                                <th>No-Operated Days</th>
                                <th className='text-center'>Edit</th>
                                <th className='text-center'>Remove</th>
                                <th className='text-center'>Active/Inactive</th>
                            </tr>
                        </thead>
                        <tbody id="location-data">
                            {NonOperatingDateList?.NonOperatingDay?.length > 0 && convertOpertedDaysTableFormat(NonOperatingDateList?.NonOperatingDay)?.map((element, index) => {
                                return (
                                    <tr className="ReactTable" key={element?.NonOperatingDay?.time + element?.NonOperatingDay?.DaysName}>
                                        <td >{element?.NonOperatingDay?.date} </td>
                                        <td className=''>{element?.NonOperatingDay?.time}</td>
                                        <td className=''>{element?.NonOperatingDay?.DaysName}</td>
                                        <td className='text-center'>
                                            <button
                                                type="button"
                                                onClick={(e) => { handleSlotEdit(element, index) }}
                                                className="btn btn-primary mx-1"
                                                disabled={disabled ? true : false}
                                            >
                                                Edit
                                            </button>
                                        </td>
                                        <td className='text-center'>
                                            <button
                                                type="button"
                                                onClick={(e) => { handleSlotRemove(index) }}
                                                className="btn btn-primary mx-1"
                                                disabled={disabled ? true : false}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                        <td className='text-center'>
                                            <Switch
                                                onChange={(val) => handleisActive(val, index)}
                                                checked={element?.isActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
});

export default NonOperatingDateTimeSection